// Shared by Cloud Functions and the frontend (imported there as @shared).
//
// Leaderboard categories: per-game averages (`per`: stat keys summed),
// percentages (`made` / `att`) with a minimum attempts per game, or ratios
// (`num` / `den`, e.g. assists per turnover) with a minimum `num` per game.

export const LEADER_CATEGORIES = [
  {key: "pts", label: "Points", short: "PPG", per: ["pts"]},
  {key: "reb", label: "Rebounds", short: "RPG", per: ["oreb", "dreb"]},
  {key: "ast", label: "Assists", short: "APG", per: ["ast"]},
  {key: "stl", label: "Steals", short: "SPG", per: ["stl"]},
  {key: "blk", label: "Blocks", short: "BPG", per: ["blk"]},
  {key: "min", label: "Minutes", short: "MPG", per: ["min"]},
  {key: "astTo", label: "Assist-to-turnover", short: "AST/TO", num: "ast",
    den: "tov", minNum: 2},
  {key: "fgm", label: "Field goals made", short: "FGM", per: ["fgm"]},
  {key: "tpm", label: "3-pointers made", short: "3PM", per: ["tpm"]},
  {key: "ftm", label: "Free throws made", short: "FTM", per: ["ftm"]},
  {key: "fgPct", label: "Field goal %", short: "FG%", made: "fgm", att: "fga",
    minAtt: 5},
  {key: "tpPct", label: "3-point %", short: "3P%", made: "tpm", att: "tpa",
    minAtt: 2},
  {key: "ftPct", label: "Free throw %", short: "FT%", made: "ftm", att: "fta",
    minAtt: 2},
];

/**
 * @param {object} cat a LEADER_CATEGORIES entry
 * @param {number} value
 * @return {string} "18.4", "2.35" or "47.3%"
 */
export function formatLeaderValue(cat, value) {
  if (cat.per) return value.toFixed(1);
  if (cat.num) return value.toFixed(2);
  return `${(value * 100).toFixed(1)}%`;
}
